import axios from "axios";
import OSS from "ali-oss";
import {
    Notification,
} from "element-ui";
import store from "@/vuex";

const PreviewFile = async function (filename, cb) {

    await axios.get('/api/get/aliyun/sts', {
            headers: {
                "Authorization": store.getters.token,
                "X-Requested-With": "XMLHttpRequest"
            }
        }).then(res => {
           
            var client_cdn = new OSS({
                region: "oss-cn-zhangjiakou",
                accessKeyId: res.data.AccessKeyId,
                accessKeySecret: res.data.AccessKeySecret,
                stsToken: res.data.SecurityToken,
                bucket: 'steamfun-cdn',
                secure: true
            });

            console.log("token 动态获取");
            console.log(res);

            console.log(client_cdn);
            
            console.log(filename);
            
            let fileposition = filename.split(`https://wugecdn.steam.fun/`)[1];
            console.log(fileposition);
             
            let signUrl = client_cdn.signatureUrl(fileposition, {
                expires: 1000 * 60 * 60 * 2,
                'process': 'imm/previewdoc,copy_1'
            });
             
            cb(signUrl);




        })
        .catch(err => {
            Notification({
                title: "警告",
                message: err,
                type: "warning"
            });
            return new Promise(function (resolve, reject) {
                reject(new Error("获取token失败"));
            });
        });
};

export default PreviewFile;